"use strict";
// Cookie 操作工具函數
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = getCookie;
exports.getAuthToken = getAuthToken;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.setCrossDomainCookie = setCrossDomainCookie;
/**
 * 獲取指定名稱的 Cookie 值
 * @param name Cookie 名稱
 * @returns Cookie 值，如果不存在則返回 null
 */
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return parts.pop()?.split(';').shift() || null;
    return null;
}
/**
 * 取得登入 token（給 API 的 Authorization header 用）
 * 只認 cookie：checkAuthStatus、identity-service 都以 cookie 為準。
 * 舊版前端曾把 token 存在 localStorage 且讀取時優先，過期後每支 API 都 401 →
 * 跳 /login → SSO 判定已登入又跳回來，無限循環；換帳號時還會用前一個帳號的 token。
 * 遇到舊值就順手清掉。
 */
function getAuthToken() {
    try {
        if (localStorage.getItem('auth_token') !== null)
            localStorage.removeItem('auth_token');
    }
    catch {
        // localStorage 不可用（無痕、被封鎖）時略過
    }
    return getCookie('auth_token');
}
/**
 * 設定 Cookie
 * @param name Cookie 名稱
 * @param value Cookie 值
 * @param options Cookie 選項
 */
function setCookie(name, value, options = {}) {
    const { domain, path = '/', secure = false, sameSite = 'lax', maxAge } = options;
    let cookieString = `${name}=${value}; path=${path}`;
    if (domain)
        cookieString += `; domain=${domain}`;
    if (secure)
        cookieString += `; secure`;
    if (sameSite)
        cookieString += `; samesite=${sameSite}`;
    if (maxAge)
        cookieString += `; max-age=${maxAge}`;
    document.cookie = cookieString;
}
/**
 * 刪除指定名稱的 Cookie
 * @param name Cookie 名稱
 * @param domain Cookie 域名 (可選)
 */
function deleteCookie(name, domain) {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    if (domain)
        cookieString += `; domain=${domain}`;
    document.cookie = cookieString;
}
/**
 * 設定跨域 Cookie (用於 SSO)
 * @param name Cookie 名稱
 * @param value Cookie 值
 * @param productionDomain 生產環境的域名 (例如: '.redpanda-tech.com')
 */
function setCrossDomainCookie(name, value, productionDomain) {
    const isProduction = window.location.hostname.includes(productionDomain.replace('.', ''));
    if (isProduction) {
        setCookie(name, value, {
            domain: productionDomain,
            path: '/',
            secure: true,
            sameSite: 'none',
            maxAge: 7 * 24 * 60 * 60 // 7 days
        });
    }
    else {
        setCookie(name, value, {
            path: '/',
            sameSite: 'lax',
            maxAge: 7 * 24 * 60 * 60 // 7 days
        });
    }
}
